import { take, call, put, fork } from 'redux-saga/effects';
import {
  fetchInformationList,
  successFetchInformationList,
  failFetchInformationList,
} from '../actions/information';
import superFetch from '../modules/superFetch';

export function* handleFetchInformationList() {
  while (true) {
    yield take(`${fetchInformationList}`);
    const jwt = localStorage.getItem('jwt');
    const { payload, err } = yield call(superFetch, {
      url: '/api/information',
      type: 'GET',
      custom: {
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      },
    });

    if (payload && !err) {
      yield put(successFetchInformationList(Object.assign({}, payload)));
      continue;
    }
    yield put(failFetchInformationList(String(err)));
  }
}

//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handleFetchInformationList);
}



// WEBPACK FOOTER //
// ./src/sagas/information.js